<template>
    <div class="page">
      <div class="page-content">
        <div>
          <h2 v-html="focus.paragraphe1 ? focus.paragraphe1.titre : ''"></h2>
          <p v-html="focus.paragraphe1 ? focus.paragraphe1.texte : ''"></p>
          <img :src="focus.paragraphe1 ? focus.paragraphe1.image : ''">
        </div>
        <div>
          <h2 v-html="focus.paragraphe2 ? focus.paragraphe2.titre : ''"></h2>
          <p v-html="focus.paragraphe2 ? focus.paragraphe2.texte : ''"></p>
        </div>
        <div>
          <h2 v-html="focus.paragraphe3 ? focus.paragraphe3.titre : ''"></h2>
          <p v-html="focus.paragraphe3 ? focus.paragraphe3.texte : ''"></p>
        </div>
        <div>
          <h2 v-html="focus.paragraphe4 ? focus.paragraphe4.titre : ''"></h2>
          <p v-html="focus.paragraphe4 ? focus.paragraphe4.texte : ''"></p>
        </div>
        <div>
          <h2 v-html="focus.paragraphe5 ? focus.paragraphe5.titre : ''"></h2>
          <p v-html="focus.paragraphe5 ? focus.paragraphe5.texte : ''"></p>
        </div>
        <div>
          <h2 v-html="focus.paragraphe6 ? focus.paragraphe6.titre : ''"></h2>
          <p v-html="focus.paragraphe6 ? focus.paragraphe6.texte : ''"></p>
        </div>
        <div>
          <h2 v-html="focus.paragraphe7 ? focus.paragraphe7.titre : ''"></h2>
          <p v-html="focus.paragraphe7 ? focus.paragraphe7.texte : ''"></p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { getFocus } from '../../mixins/getFocus'
  
  export default {
    name: 'BaremeHonoraire',
    mixins: [getFocus],
    data() {
      return {
        focus: {},
      }
    },
    async beforeMount() {
      await this.getFocus('ti', 'Barème')
        .then(res => {
          this.focus = res
        })
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .page-content {
    padding: 16px;

    &>div {
      max-width: 900px;
    }
    img {
      width: 100%;
    }
  }
  </style>
  